import { useEffect, useMemo } from 'react'
import { TorchApplicationTypes, useTorchApplication } from '../components/TorchApplicationContext'
import { Agreement } from './Agreement'
import { AssociatedProject } from './AssociatedProject'
import { Details } from './Details'
import { FilmApplicationPayment, TorchApplicationPayment } from './Payment'
import { Splash } from './Splash'
import { Upload } from './Upload'

const torchPages = [Splash, Details, Agreement, Upload, TorchApplicationPayment]
const episodePage = [Splash, Details, Agreement, Upload, AssociatedProject, TorchApplicationPayment]
const fullFilmPages = [Splash, Details, Agreement, Upload, FilmApplicationPayment]

export const TorchApplicationPages = () => {
  const { pageIndex, type } = useTorchApplication()
  const isFullFilm = useMemo(() => type === TorchApplicationTypes.FullFilm, [type])
  const isEpisode = useMemo(() => type === TorchApplicationTypes.CompletedEpisode, [type])

  const PageComponent = useMemo(() => {
    if (isFullFilm) return fullFilmPages[pageIndex]
    if (isEpisode) return episodePage[pageIndex]

    return torchPages[pageIndex]
  }, [pageIndex, isFullFilm, isEpisode])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pageIndex])

  return PageComponent ? <PageComponent /> : <Splash />
}
